import { shopifyFecth } from "./share";

export const getAppId = async () => {
  const data = await shopifyFecth({
    query: `
          query {
            currentAppInstallation {
              id
              app{
                id
              }
              metafields(first:20){
                nodes{
                  id
                  key
                  namespace
                  value
                }
              }
              activeSubscriptions {
                name
                status
              }
            }
          }
        `,
  });

  return data.currentAppInstallation as {
    id: string;
    app: { id: string };
    activeSubscriptions: { name: string; status: string }[];
    metafields: {
      nodes: { key: string; namespace: string; value: string; id: string }[];
    };
  } | null;
};

export const getShop = async () => {
  const data = await shopifyFecth({
    query: `
{
	shop {
		name
    id
    ianaTimezone
    timezoneOffset
    plan{
      partnerDevelopment
    }
  }
}`,
  });

  return data.shop as {
    shop: string;
    plan: { partnerDevelopment: boolean };
    id: string;
    ianaTimezone: string;
    timezoneOffset: string;
  } | null;
};

export const getFunctions = async () => {
  const data = await shopifyFecth({
    query: `
        query {
            shopifyFunctions(first: 25) {
              nodes {
                app {
                  title
                  id
                }
                apiType
                title
                id
              }
            }
          }
        `,
  });

  return data.shopifyFunctions as {
    nodes: {
      apiType: string;
      app: { title: string; id: string };
      id: string;
      title: string;
    }[];
  } | null;
};
